var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch, Prop, Model } from "vue-facing-decorator";
import { MaintenanceLogsClient, GetAlarmsLogPaginatedQuery, CreateMaintenanceLogCommand, UpdateMaintenanceLogCommand, MaintenanceLogModel, PaginatedEnumerableOfMaintenanceLogModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import moment from 'moment';
const maintenanceClient = new MaintenanceLogsClient(window.apiUrl);
let AlarmCommentsVue = class AlarmCommentsVue extends Vue {
    constructor() {
        super(...arguments);
        this.showModal = false;
        this.alarmIds = [];
        this.componentId = null;
        this.systemId = 0;
        // simpletons
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        this.pageNo = 1;
        this.hasChanges = false;
        // models
        this.log = new MaintenanceLogModel();
        this.editingLog = null;
        this.logs = new PaginatedEnumerableOfMaintenanceLogModel();
        this.maxCommentLength = 5000;
    }
    created() {
    }
    ;
    mounted() {
    }
    ;
    initLog() {
        this.log = new MaintenanceLogModel();
        this.attemptedSave = false;
        this.editingLog = null;
        this.pageNo = 1;
        this.log.init({
            whenEntered: new Date()
        });
        this.setValues({
            comment: this.log.notes
        });
    }
    getLogs() {
        var query = new GetAlarmsLogPaginatedQuery({
            pageNo: this.pageNo,
            pageSize: 10,
            alarmIds: this.alarmIds
        });
        this.working = true;
        maintenanceClient
            .getAlarmsComments(query)
            .then(response => {
            if (!response) {
                return;
            }
            if (response.displayedPage == this.pageNo && response.records) {
                let allLogs = this.logs.records ? this.logs.records.concat(response.records) : response.records;
                this.logs = response;
                this.logs.records = allLogs;
            }
            else {
                this.logs.recordCount == response.recordCount;
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLog(logId) {
        var query = new GetAlarmsLogPaginatedQuery({
            pageNo: this.pageNo,
            pageSize: 10,
            alarmIds: this.alarmIds
        });
        this.working = true;
        maintenanceClient
            .get(logId)
            .then(response => {
            if (!response) {
                return;
            }
            this.logs.records = [response].concat(this.logs.records);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    loadMore() {
        this.pageNo++;
        this.getLogs();
    }
    // set
    save() {
        if (this.working)
            return;
        this.attemptedSave = true;
        this.setValues({
            comment: this.log.notes
        });
        const handleSubmitAction = this.handleSubmit(() => {
            let log = this.log;
            log.whenEntered = new Date();
            log.systemId = this.systemId;
            log.alarmIds = this.alarmIds;
            log.componentId = this.componentId;
            this.working = true;
            maintenanceClient
                .add(new CreateMaintenanceLogCommand({ requestModel: this.log }))
                .then(logId => {
                Notifier.onOk();
                this.getLog(logId);
                this.initLog();
                this.hasChanges = true;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    update() {
        if (this.working || !this.editingLog)
            return;
        this.working = true;
        maintenanceClient
            .update(this.editingLog.logId, new UpdateMaintenanceLogCommand({ requestModel: this.editingLog }))
            .then(logId => {
            Notifier.onOk();
            this.editingLog = null;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    cancel() {
        this.$confirmModal.show("Are sure you want to cancel this comment?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.initLog();
        });
    }
    cancelEditing() {
        this.$confirmModal.show("Are sure you want to cancel this comment?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.editingLog = null;
        });
    }
    edit(log) {
        this.editingLog = log;
    }
    remove(log) {
        if (!this.logs.records)
            return;
        this.$confirmModal.show("Are you you want to remove this comment?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            maintenanceClient.delete(log.logId)
                .then(() => {
                this.logs.records = this.logs.records.filter(item => item.logId != log.logId);
                Notifier.onOk(`Comment has been successfully removed.`);
                this.hasChanges = true;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    onHidden() {
        if (this.hasChanges === true)
            this.$emit('onReload');
    }
    onShow() {
        if (this.showModal) {
            this.logs = new PaginatedEnumerableOfMaintenanceLogModel();
            this.initLog();
            this.getLogs();
        }
    }
    getFormattedDate(date) {
        return moment(date).format("DD MMM YYYY, HH:mm a");
    }
    getCommentLength(notes) {
        return notes ? notes.length : 0;
    }
    // computed
    get isNewLog() {
        return !this.editingLog;
    }
    ;
    isEditingLog(log) {
        var _a;
        return ((_a = this.editingLog) === null || _a === void 0 ? void 0 : _a.logId) == log.logId;
    }
    hasMoreLogs() {
        var result = this.logs.recordCount > (this.pageNo * this.logs.pageSize);
        return result;
    }
};
__decorate([
    Model,
    __metadata("design:type", Boolean)
], AlarmCommentsVue.prototype, "showModal", void 0);
__decorate([
    Prop,
    __metadata("design:type", Array)
], AlarmCommentsVue.prototype, "alarmIds", void 0);
__decorate([
    Prop,
    __metadata("design:type", Object)
], AlarmCommentsVue.prototype, "componentId", void 0);
__decorate([
    Prop,
    __metadata("design:type", Number)
], AlarmCommentsVue.prototype, "systemId", void 0);
__decorate([
    Watch("showModal"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AlarmCommentsVue.prototype, "onShow", null);
AlarmCommentsVue = __decorate([
    Component({
        name: "AlarmCommentsVue",
        emits: ['onReload'],
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setValues } = useForm({
                validationSchema: yup.object({
                    comment: yup.string().trim().required(),
                }),
            });
            const commentVal = defineInputBinds('comment');
            return {
                errors,
                handleSubmit,
                setValues,
                commentVal
            };
        }
    })
], AlarmCommentsVue);
export default AlarmCommentsVue;
